import { Component } from 'lib'
import locale from 'Common/Locale/Locale'

class CookiePreferences extends Component {
  /**
   * @type {{ consentManagementService: import('Common/Service/Consent/types.js').IConsentManagementService }}
   */
  context

  render () {
    return (
      <button
        class="link"
        onClick={ () => {
          this.context.consentManagementService.renderPreferences()
        } }
        type="button">
        { locale.translate('footer.cookie') }
      </button>
    )
  }
}

export default CookiePreferences
